module.exports = __webpack_public_path__ + "img/success.17765af4.png";